import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["svg"]
  static values = {
    filename: { type: String, default: "qrcode.png" },
    size: { type: Number, default: 1024 },
    padding: { type: Number, default: 40 }
  }

  download() {
    const svgElement = this.svgTarget.querySelector("svg")
    if (!svgElement) return

    if (!svgElement.getAttribute("xmlns")) {
      svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg")
    }

    const svgData = new XMLSerializer().serializeToString(svgElement)
    const canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d")
    const size = this.sizeValue
    const padding = this.paddingValue

    canvas.width = size + padding * 2
    canvas.height = size + padding * 2

    const img = new Image()

    img.onload = () => {
      ctx.fillStyle = "#ffffff"
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.imageSmoothingEnabled = true
      ctx.imageSmoothingQuality = "high"
      ctx.drawImage(img, padding, padding, size, size)

      canvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = url
        a.download = this.filenameValue
        a.click()
        URL.revokeObjectURL(url)
      }, "image/png")
    }

    const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" })
    const url = URL.createObjectURL(svgBlob)
    img.src = url
  }

  print() {
    window.print()
  }
}
